import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Loader2, Shield } from 'lucide-react';
import StartupPage from '../../pages/StartupPage';

interface ProtectedRouteProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, fallback }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface">
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <div className="h-12 w-12 rounded-lg bg-gradient-to-br from-primary-600 to-primary-800 flex items-center justify-center">
              <Shield className="h-6 w-6 text-white" />
            </div>
          </div>
          <Loader2 className="h-8 w-8 animate-spin text-primary-600 mx-auto mb-4" />
          <h2 className="text-lg font-semibold text-content mb-2">Loading ElectroPLM</h2>
          <p className="text-content-secondary">Authenticating your session...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return fallback || <StartupPage />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;